import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { alphaNumericUppercase, decryptData, encryptData, handlePasteText, noDataFound } from "../../../CommonMethhods/CommonMethods";
import moment from "moment";
import { toast } from "react-toastify";
import approveIcon from "../../../asset/images/righticon-green.svg";
import rejIcon from "../../../asset/images/cancelRed-Icon.svg";
import attachIcon from "../../../asset/images/attach.svg";
import axiosInstance, { axiosInstance0 } from "../../../CommonMethhods/axiosInstance";
import { Dealer_Mapping } from "../../../Configuration/API_URL";
import Loader from "../../../Components/Common/Loader";
import infoIcon from "../../../../src/asset/images/yellow-info.svg";
import SmallLoader from "../../../Components/Common/smallLoader";

function PendingApprovals() {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [checkerData, setCheckerData] = useState([]);
  const [remarksInput, setRemarksInput] = useState("");
  const [rejectDetails, setRejectDetails] = useState(null);
  const [approveDetails, setApproveDetails] = useState(null);
  const [loader, setLoader] = useState(false);

  const chkReviewTableData = async () => {
    setLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        Dealer_Mapping.checkerPreview,

      );
      const res = JSON.parse(decryptData(getDetails.data));
      console.log(res, "checkerRes");
      if (res?.status === 0) {
        setCheckerData(res?.data)
        if (res?.data?.length > 0) {
          setOpenAccordion(res?.data[0]?.batchId);
        }
      } else {
        setCheckerData([]);
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    chkReviewTableData();
  }, []);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const updateStatus = async ({
    batchId,
    requestId = null,
    action,
    reason = "",
  }) => {
    let endpoint = "";
    let payload = null;


    switch (action) {
      case "approve":
      case "reject":
        endpoint = `${Dealer_Mapping.singleMappingSubmit}/${batchId}/row-status`;

        payload = {
          requestId,
          action,
          ...(action === "reject" && { reason }),
        };
        break;

      case "approve-all":
        endpoint = `${Dealer_Mapping.singleMappingSubmit}/${batchId}/approve-all`;
        break;

      case "reject-all":
        endpoint = `${Dealer_Mapping.singleMappingSubmit}/${batchId}/reject-all`;

        payload = {
          reason,
        };
        break;

      default:
        return;
    }
    console.log(payload, "payloadStatus");

    try {
      const encryptedPayload = encryptData(JSON.stringify(payload))   
      
       
      const response = await axiosInstance.put(
        endpoint,
        encryptedPayload,
        {
        transformRequest: [(data) => data],
        }
      );

      const res = decryptData(response.data);
      let decryptedRes = JSON.parse(res);      
      if (decryptedRes.status === 0) {
        toast.success(decryptedRes.message);
        chkReviewTableData();
      } else {
        toast.error(decryptedRes.message);
      }
    } catch (err) {
      console.log(err, "catcherr");
      toast.error("Something went wrong");
    }
  };

  const openApprovalModal = ({ batchId, requestId = null, action }) => {
    setApproveDetails({
      batchId,
      requestId,
      action,
    });
    setShowApprovalModal(true);
  };

  const openRejectModal = ({ batchId, requestId = null, action }) => {
    setRejectDetails({
      batchId,
      requestId,
      action,
    });
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
    setRemarksInput("");
    setRejectDetails(null);
  };

  const handleApproveCancel = () => {
    setShowApprovalModal(false);
    setApproveDetails(null);
  };

  const handleSubmit = async () => {
    if (remarksInput.trim().length < 10) return;

    await updateStatus({
      batchId: rejectDetails.batchId,
      requestId: rejectDetails.requestId,
      action: rejectDetails.action,
      reason: remarksInput.trim(),
    });

    handleCancel();
  };

  const handleApprovalSubmit = async () => {
    await updateStatus({
      batchId: approveDetails.batchId,
      requestId: approveDetails.requestId,
      action: approveDetails.action,
    });
    handleApproveCancel();
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const remarksLength = remarksInput.trim().length;
const pendingMinChars = Math.max(0, 10 - remarksLength);
const remainingChars = 500 - remarksInput.length;

  return (
    <>
      <div className="ckr-page new-upload">
        <div className="ckr-section-header">
          <p className="ckr-section-title">Checker Review Queue</p>
        </div>

        {loader ?
          <div className="loader-alignment">
            <Loader />
          </div>
          :
          checkerData?.length > 0 ?
            checkerData.map((item, index) => (
              <div className="dl-checker-card" key={item.batchId}>
                <div className="step-content mb-extra">
                  <div className="client-header border-bottom mb-15" onClick={() => toggleAccordion(item?.batchId)}>
                    <div className="client-wrapper">
                      <span className="initials"> {item?.makerId?.slice(0, 2).toUpperCase()}</span>
                      <div className="cl-wrapper">
                        <span className="cl-name">{item?.makerId}</span>
                        <div className="client-code">
                          {item?.batchId} · {moment(item?.submittedAt).format("DD-MM-YYYY")}
                        </div>
                      </div>
                    </div>
                    <div className="checker-actions mapping-footer-actions">
                      
                      {item.approvalDocFilename && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip
                              id="file-tooltips"
                              // className="file-tooltip"
                            >
                              {item?.approvalDocFilename}
                            </Tooltip>
                          }
                        >
                          <span
                            className="checker-document"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(item?.approvalDocLink, "_self", "noopener,noreferrer");
                            }}
                          >
                            <img src={attachIcon} alt="attach icon" />
                            <span className="file-name">{item?.approvalDocFilename}</span>
                          </span>
                        </OverlayTrigger>
                      )}

                      {item?.batchId?.toUpperCase()?.startsWith("BLK") &&
                      <div className="app-rej-btns">
                        <button
                          className="submit-btns"
                          onClick={(e) =>{
                            e.stopPropagation();
                            openApprovalModal({
                              batchId: item.batchId,
                              action: "approve-all",
                            })
                          }
                          }
                        >
                          APPROVE ALL
                        </button>

                        <button
                          className="back-btn"
                          onClick={(e) =>{
                            e.stopPropagation();
                            openRejectModal({
                              batchId: item.batchId,
                              action: "reject-all",
                            })
                          }
                          }
                        >
                          REJECT ALL
                        </button>
                      </div>
                      }
                    </div>
                  </div>


                  {openAccordion === item.batchId && (
                    <div className="checker-card-body">
                      <div className="wrap-dl-checker">
                        <div className="valid-count">
                          <span className="bold-text">Valid:{item.totalValidCount}</span>
                        </div>
                        <div className="wrap-upload">
                          <span className="records">{item.requests.length} Quantity</span>

                        </div>
                      </div>

                      <div className="ckr-table-wrapper dl-checker-table">
                        <table className="ckr-table draft-maker">
                          <thead>
                            <tr>
                              <th>Request Date</th>
                              <th>Maker ID</th>
                              <th>UCC / Client Code</th>
                              <th>Dealer Code</th>
                              <th>Effective Date</th>
                              <th>Reason</th>
                              <th>Raw Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {item.requests.map((row, index) => (
                              <tr key={index}>
                                <td>{moment(row?.reqDate).format("DD-MM-YYYY") || "-"}</td>
                                <td>{item?.makerId || "-"}</td>
                                <td>{row?.ucc || "-"}</td>
                                <td>{row?.newDealerCode || "-"}</td>
                                <td>{moment(row?.startDate).format("DD-MM-YYYY") || "-"}</td>
                                <td>{row?.reason || "-"}</td>
                                <td>
                                  <div className="row-actions">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id="approve-tooltip" className="approve-tooltip">Approve</Tooltip>}
                                    >
                                      <button
                                        className="status-btns"
                                        onClick={(e) =>{
                                          e.currentTarget.blur();

                                          openApprovalModal({
                                            batchId: item.batchId,
                                            requestId: row.requestId,
                                            action: "approve",
                                          })
                                        }}
                                      >
                                        <img src={approveIcon} alt="Approve" />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id="reject-tooltip" className="reject-tooltip">Reject</Tooltip>}
                                    >
                                      <button
                                        className="status-btns"
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          openRejectModal({
                                            batchId: item.batchId,
                                            requestId: row.requestId,
                                            action: "reject",
                                          });
                                        }}
                                      >
                                        <img src={rejIcon} alt="Reject" />
                                      </button>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
            :
            <div className="step-content report-error-message">
              {noDataFound()}
            </div>
        }
      </div>

      {showModal && (
        <div className="ckr-modal-overlay">
          <div className="ckr-modal ckr-modal-cdm" onClick={(e) => e.stopPropagation()}>
            <div className="ckr-modal__header">
              <span>Rejection Remarks <span className="mandate-mark">*</span></span>
              <button className="ckr-modal__close" onClick={handleCancel}>
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="ckr-modal__body">
              <textarea
                placeholder="Enter remarks here..."
                value={remarksInput}
                rows={5}
                minLength={10}
                maxLength={500}
                autoFocus
                onChange={(e) =>
                  setRemarksInput(alphaNumericUppercase(e.target.value, 500))
                }
                onPaste={handlePasteText({
                  value: remarksInput,
                  setValue: setRemarksInput,
                  maxLength: 500,
                  regex: /[^A-Z0-9\s]/g,
                })}
              />
              <div
                className={`char-count ${
                  remarksLength < 10 ? "char-count-error" : ""
                }`}
              >
                {remarksLength < 10 ? (
                  <span>
                    Minimum {10 - remarksLength} character
                    {10 - remarksLength > 1 ? "s are" : " is"} required
                    {" "}({remarksInput.length}/500)
                  </span>
                ) : (
                  <span>{remainingChars} characters remaining</span>
                )}
              </div>
            </div>
            <div className="ckr-modal__footer">
              

              <button className="ckr-modal__cancel" onClick={handleCancel}>CANCEL</button>
              <button
                className="ckr-modal__submit"
                onClick={handleSubmit}
                disabled={remarksInput.trim().length < 10}
              >
                SUBMIT
              </button>
            </div>
            
          </div>
          
        </div>
      )}

       <Modal
        show={showApprovalModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new delete-modal approval-modal"
      >
        <Modal.Body>
          <div className="close-button-modal approval-modal-wrap">
            
            <button
              type="button"
              onClick={() => setShowApprovalModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="profile-modal-content">
            <div className='iba-worning approval-warning'>
              <div className="wrap-infoicon batch-wraps">
              <img src={infoIcon} alt="email icon" className="info-icon" />
              <span className="app-modal-title">Approve Batch — {approveDetails?.batchId}</span>
          </div>
              <span className='conf-text approval-content'>Are you sure you want to Approve the record ?</span>
            </div>

            <div className="modal-footer-actions check-approve-modal">
                <button className="back-btn" onClick={() => {
                  setShowApprovalModal(false);
                }}>CANCEL</button>
                <button className="submit-btns" 
                onClick={handleApprovalSubmit}>
                  CONFIRM BATCH APPROVAL
                </button>
              </div>

            
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PendingApprovals;